module.exports = __webpack_public_path__ + "img/SGH09.13a6868e.jpg";